enum API {
	USERS = '/api/settings/users',
	PROFILE = '/api/settings/users/profile'
}

export default API;
